<template>
  <CardWithTitle
    :item-id="itemId"
    :request-status="requestStatus"
    :options-data="baseCardOptions"
    @call-option-menu="callOptionMenu"
    @reload="$emit('reload', $event)"
  >
    <template #top-right-slot>
      <ExportBtn>
        <v-list>
          <v-list-item
            @click="exportXlsx"
          >
            <v-list-item-title>
              {{ exportLabel }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </ExportBtn>
      <template v-if="hasFilter">
        <DsButton
          v-tooltip="filterButton"
          color="tertiary"
          name="filter"
          :icon="true"
          @click="openFilter"
        />
      </template>
      <DsButton
        v-tooltip="infoLabel"
        color="tertiary"
        name="questions"
        :icon="true"
        @click="openDialog"
      />
    </template>
  </CardWithTitle>
</template>

<script>

import CardWithTitle from '@/components/cards/models/CardWithTitle';
import ExportBtn from '@/components/ExportBtn';
import cardsModel from '@/mixins/cards-model';
import { DsButton } from '@ds/components';

export default {
  name: 'MultibarChart',
  components: {
    CardWithTitle,
    ExportBtn,
    DsButton,
  },
  mixins: [
    cardsModel,
  ],
  props: {
    requestStatus: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    hasFilter: {
      type: Boolean,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    exportXlsx: {
      type: Function,
      default: () => {},
    },
    openDialog: {
      type: Function,
      default: () => {},
    },
    openFilter: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      exportLabel: this.$t('components.OperatorsLogs.export'),
      infoLabel: this.$t('components.OperatorsLogs.infoLabel'),
      filterButton: this.$t('components.OperatorsLogs.filterLabel'),
    };
  },
};
</script>

<style scoped lang="scss">
  .multibar-chart {
    width: 100%;
  }
</style>
